(function calculateBTU() {
const powerPacks = [
  { model: "826-MMPP4301", btu: 2300 },
  { model: "826-MMPP4302", btu: 3600 },
  { model: "826-MMPP4303", btu: 5100 },
  { model: "826-MMPP4305", btu: 7500 },
  { model: "826-MMPP4307", btu: 11500 },
];

  function initBTUCalculator() {

    const faucetsInput = document.getElementById("faucets");
    const lengthInput = document.getElementById("length");
    const sizeSelect = document.getElementById("size");
    const result = document.getElementById("result");
    const recommendationBox = document.getElementById("recommendationBox");

    if (!faucetsInput || !lengthInput || !sizeSelect || !result) {
      return;
    }

    function calculateBTU() {

      const faucets = parseFloat(faucetsInput.value) || 0;
      const length = parseFloat(lengthInput.value) || 0;

      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      const trunkBTUperFt = parseFloat(
        selectedOption.getAttribute("data-btu")
      ) || 0;

      const requiredBTU =
        ((faucets * 100) + (length * trunkBTUperFt)) * 1.4;

      result.textContent = requiredBTU.toFixed(0) + " BTU/hr";

      // Find recommendation
      if (recommendationBox) {

        let recommended = powerPacks.find(pack => pack.btu >= requiredBTU);

        if (!recommended) {
          recommendationBox.textContent =
            "System exceeds standard power pack sizes. Contact us for custom sizing.";
        } else {
          recommendationBox.innerHTML =
            "Recommended Power Pack: <strong>" +
            recommended.model +
            "</strong> (" +
            recommended.btu +
            " BTU Capacity)";
        }
      }
    }

    faucetsInput.addEventListener("input", calculateBTU);
    lengthInput.addEventListener("input", calculateBTU);
    sizeSelect.addEventListener("change", calculateBTU);

    calculateBTU();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBTUCalculator);
  } else {
    initBTUCalculator();
  }

})();